export default __webpack_public_path__ + "static/media/metamask.c2e1ac04.svg";